var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ spinner: true, full: _vm.full }},[_c('Icon',{staticClass:"icon",attrs:{"type":"spinner","size":"30px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }